import "./scss/GLS.scss";
import "./css/leaflet.css";

import WooCommerce from "./js/GLS-woo-commerce.js";
import GLSWidget from "./js/GLS-widget";

/**
 * Class GLS depends on jQuery.
 * Check if we are meant to append a map
 *
 * Platform dependent functions marked with   * @platformDependent
 */
class GLS {
  constructor(ajax_url) {
    this.markers = []; //pickup {lat, lng}
    this.isMapLoaded = false;
    this.gmaps_key =
      typeof GLS_maps_key == "undefined" ? "" : GLS_maps_key;
    this.openMapMarkerIcons = {};
    this.ajax_url = ajax_url; // platform dependent

    // ✅ Track if scripts are preloading
    this.scriptsPreloaded = false;
    this.addressPreGeocoded = false;

    this.platform = new WooCommerce(this.ajax_url);

    this.platform.isCheckout();
    this.init();
  }

  init() {
    this.GLSWidget = new GLSWidget({
      host: "https://GLS.me",
      address: this.platform.getShippingData().Address,
      labels: {},
      mapParentContainer: "body",
      buttonParentContainer: "body",
      buttonClass: "",
      ajax_url: this.ajax_url,
      carrierId: this.platform.getShippingData().CarrierId,
      onPointSelected: () => {},
      gmapskey:
        typeof GLS_maps_key == "undefined" ? "" : GLS_maps_key,
    });
    this.GLSWidget.init();

    // ✅ Preload map resources in the background
    this.preloadMapResources();
  }

  /**
   * ✅ NEW: Preload map scripts and geocode address in background
   */
  preloadMapResources() {
    setTimeout(() => {
      // ✅ 1. Preload map scripts
      if (this.GLSWidget.mapinterface && !this.scriptsPreloaded) {
        this.scriptsPreloaded = true;

        if (jQuery("#sw").length === 0) {
          this.GLSWidget.addMapHtml();
        }
      }
    }, 2000);
  }
  /**
   * ✅ NEW: Pre-fetch pickup points in background
   */
  preFetchPickupPoints() {
    // Only if we have carrier ID and geocoded address
    if (
      !this.GLSWidget.carrier_id ||
      !this.GLSWidget.options.address.Lat
    ) {
      return;
    }

    const req = {
      Address: this.GLSWidget.options.address,
      CarrierId: this.GLSWidget.carrier_id,
      action: "GLS_pickup_locations",
    };

    jQuery
      .getJSON(this.ajax_url, req, (data) => {
        if (data && data.Point && data.Point.length > 0) {
          // ✅ Cache the results
          const cacheKey = this.GLSWidget.hashLatLng({
            lat: this.GLSWidget.options.address.Lat,
            lng: this.GLSWidget.options.address.Long,
          });

          this.GLSWidget.cacheResults[cacheKey] = data;
        }
      })
      .fail(() => {
        console.log("⚠️ Pre-fetch failed (not critical)");
      });
  }

  getPickupLocations(evt) {
    const carrierId =
      parseInt(jQuery("#shipping_carrier_id").val()) ||
      (window.GLSPickupManager &&
        window.GLSPickupManager.carrier_id);
    if (carrierId) {
      this.GLSWidget.carrier_id = carrierId;
      this.GLSWidget.setCarrierId &&
        this.GLSWidget.setCarrierId(carrierId);
    }
    // ✅ Remove any stale loaders before opening
    jQuery(".GLS-loader-btn").stop(true, true).remove();
    this.GLSWidget.openMap(); // openMap() handles its own loader
  }
}

jQuery(function () {
  if (typeof woocommerce_params != "undefined") {
    window.GLS = new GLS(woocommerce_params.ajax_url);
  }
});
